@if (!!model) {
  <div>
    <app-slip-component-header type="consent" [status]="model.status"></app-slip-component-header>
    <hr />
    <div class="fixed-content-container">
      <app-student-slip-consent-info
        [ngClass]="showInfo ? 'visible' : 'hidden'"
        [question]="model.question"
        [response]="model.response">
      </app-student-slip-consent-info>
      @if (renderForm) {
        <app-student-slip-consent-form
          [ngClass]="showInfo ? 'hidden' : 'visible'"
          [question]="model.question"
          [canDecline]="model.canDecline"
          [enableDeclineWarning]="model.enableDeclineWarning"
          [progress]="model.progress"
          (submitConsent)="submitConsent.emit($event)"
          (reloadSlip)="reloadSlip.emit()">
        </app-student-slip-consent-form>
      }
    </div>
    <!-- <pre>{{model | json}}</pre> -->
  </div>
}
